var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsx = function SvgXlsx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h18l7.5 8.625V35.5A1.5 1.5 0 0 1 29 37H5a1.5 1.5 0 0 1-1.5-1.5V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M8 .625h17.83l7.295 8.39V33.25c0 .621-.504 1.125-1.125 1.125H8a1.125 1.125 0 0 1-1.125-1.125V1.75c0-.621.504-1.125 1.125-1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M7.25 22h22.125v3.75a1.5 1.5 0 0 1-1.5 1.5H7.25V22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 13.5,
    x: 0.875,
    y: 12.25,
    fill: "#21A366",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.156 15.512 1.397 2.338h.053l1.415-2.338h1.3l-1.96 3.181 1.996 3.182H25.03l-1.424-2.32h-.053l-1.424 2.32h-1.318l2.013-3.182-1.987-3.181h1.319ZM19.062 17.26c-.057-.549-.518-.865-1.204-.86-.725-.005-1.156.347-1.16.826-.005.536.562.755 1.09.879l.597.158c.95.22 1.863.72 1.863 1.828 0 1.116-.883 1.88-2.408 1.88-1.48 0-2.421-.711-2.47-1.968h1.126c.052.663.61.989 1.335.993.752-.004 1.27-.369 1.275-.914-.004-.5-.462-.712-1.151-.888l-.721-.184c-1.046-.273-1.696-.8-1.696-1.714 0-1.125.997-1.872 2.337-1.872 1.35 0 2.268.76 2.286 1.837h-1.099ZM10.73 21.875v-6.363h1.143v5.396h2.812v.967H10.73ZM5.738 15.512l1.397 2.338h.053l1.415-2.338h1.3l-1.96 3.181 1.996 3.182H8.612l-1.424-2.32h-.053l-1.424 2.32H4.393l2.013-3.182-1.987-3.181h1.319Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M26 .25v8.625h7.5L26 .25Z"
  })));
};
export default SvgXlsx;